<template>
    <v-navigation-drawer id="core-navigation-drawer" v-model="drawer" :color="bgColor" app clipped
        :expand-on-hover="expandOnHover" :src="barImage" :permanent="$vuetify.breakpoint.mdAndUp" v-bind="$attrs">
        <v-list dense nav>
            <!-- ⚠ 走 `visibleMenu` 而不是 `menu`：「被停用的題目」平常是 0，
                 常駐在選單裡只是雜訊，所以它只在真的有題目被卡住時才出現。 -->
            <v-list-item link :href="item.url" v-for="item in visibleMenu" :key="item.title">
                <v-list-item-icon class="mr-4">
                    <v-icon color="white">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="subtitle-1 white--text">
                        {{ item.title }}
                        <v-chip v-if="item.id === 'safety' && unhandledCount > 0" x-small color="red darken-2" dark
                            class="ml-1">
                            {{ unhandledCount }}
                        </v-chip>
                        <v-chip v-if="item.id === 'blockedQuest'" x-small color="indigo darken-1" dark
                            class="ml-1">
                            {{ blockedQuestCount }}
                        </v-chip>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import { safetyAlertServices } from '@/services/safetyAlert.js';
import { blockedQuestServices } from '@/services/blockedQuest.js';
export default {
    name: "MainMenu",
    props: {
        expandOnHover: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        menu: [],
        bgColor: "deep-orange lighten-1",
        unhandledCount: 0,
        blockedQuestCount: 0,
    }),
    async created() {
        this.setMenu();
        this.setColor();
        this.loadSafetySummary();
        this.loadBlockedQuestSummary();
        this.$root.$on('safety-summary-refresh', this.loadSafetySummary);
        this.$root.$on('blocked-quest-refresh', this.loadBlockedQuestSummary);
    },
    beforeDestroy() {
        this.$root.$off('safety-summary-refresh', this.loadSafetySummary);
        this.$root.$off('blocked-quest-refresh', this.loadBlockedQuestSummary);
    },
    computed: {
        ...mapState(["barColor", "barImage", "homeworkName"]),

        /**
         * ⚠ **「被停用的題目」是選單裡唯一會消失的項目。**
         * 它的正常值是 0，而全站橫幅關掉之後就沒有別的入口了——被停用的題目在關卡列表
         * 裡看不到（`getUnitList` 只撈 `status = '1'`），所以這個入口是那些題目在關掉
         * 橫幅之後**唯一**找得回來的路。
         */
        visibleMenu() {
            return this.menu.filter(
                (item) => item.id !== 'blockedQuest' || this.blockedQuestCount > 0);
        },

        drawer: {
            get() {
                return this.$store.state.drawer;
            },
            set(val) {
                this.$store.commit("SET_DRAWER", val);
            },
        },
    },
    methods: {
        ...mapGetters(["getConsoleIndexUrl", "getHomeworkName"]),
        ...mapMutations({
            setHomeworkName: "setHomeworkName",
        }),
        mapItem(item) {
            return {
                ...item,
                children: item.children
                    ? item.children.map(this.mapItem)
                    : undefined,
            };
        },
        setMenu() {
            const mode = sessionStorage.getItem('mode');
            this.menu = [];
            if (mode == 't') {
                this.menu.push({
                    icon: 'mdi-book-open-variant',
                    title: this.$t('main_menu.journals'),
                    url: `/diary`,
                }, {
                    icon: 'mdi-book-open-outline',
                    title: this.$t('main_menu.quest'),
                    url: `/diarySample`,
                }, {
                    /// 「我的素材」（F10）。⚠ 緊接在「日記範本」之後是刻意的：
                    /// 素材目前只用於關卡式範本的題目，離開那個情境沒有意義。
                    icon: 'mdi-folder-multiple-image',
                    title: this.$t('main_menu.media_library'),
                    url: `/diarySample/media`,
                }, {
                    icon: 'mdi-account-group',
                    title: this.$t('main_menu.uploadUserData'),
                    url: `/student`,
                },
                    // {
                    //     icon: 'mdi-television',
                    //     title: this.$t('main_menu.board'),
                    //     url: `/diary/board`,
                    // },
                {
                    icon: 'mdi-account-cog',
                    title: this.$t('main_menu.team_management'),
                    url: `/team/my`,
                }, {
                    icon: 'mdi-information',
                    title: this.$t('main_menu.userChargePlanHistory'),
                    url: `/my/ucp`,
                }, {
                    icon: 'mdi-shield-alert',
                    title: this.$t('main_menu.safety_alerts'),
                    url: `/diary/safetyAlerts`,
                    id: 'safety',
                },
                {
                    icon: 'mdi-eye-off-outline',
                    title: this.$t('main_menu.blocked_quests'),
                    url: `/diarySample/blockedQuests`,
                    id: 'blockedQuest',
                }
                );
            } else {
                this.menu.push({
                    icon: 'mdi-book-open-variant',
                    title: this.$t('main_menu.journals'),
                    url: `/diary`,
                },
                    {
                        icon: 'mdi-book-open-outline',
                        title: this.$t('main_menu.quest'),
                        url: `/diarySample`,
                    },
                    {
                        /// 見上面那個分支的說明——兩個分支都要有，否則其中一種
                        /// 身分的老師永遠找不到這一頁。
                        icon: 'mdi-folder-multiple-image',
                        title: this.$t('main_menu.media_library'),
                        url: `/diarySample/media`,
                    },
                    {
                        icon: 'mdi-account-group',
                        title: this.$t('main_menu.uploadUserData'),
                        url: `/student`,
                    },
                    // {
                    //     icon: 'mdi-television',
                    //     title: this.$t('main_menu.board'),
                    //     url: `/diary/board`,
                    // },
                    {
                        icon: 'mdi-bookshelf',
                        title: this.$t('menu.diary_resource'),
                        url: `/diarySample/resourcesBook`,
                    },
                    {
                        icon: 'mdi-ticket-account',
                        title: this.$t('main_menu.userChargePlanHistory'),
                        url: `/my/ucp`,
                    },
                    {
                        icon: 'mdi-shield-alert',
                        title: this.$t('main_menu.safety_alerts'),
                        url: `/diary/safetyAlerts`,
                        id: 'safety',
                    },
                    {
                        icon: 'mdi-eye-off-outline',
                        title: this.$t('main_menu.blocked_quests'),
                        url: `/diarySample/blockedQuests`,
                        id: 'blockedQuest',
                    }
                );
            }
        },
        setColor() {
            const mode = sessionStorage.getItem('mode');
            if (mode == 't') {
                this.bgColor = '#66b799';
            } else {
                this.bgColor = 'deep-orange lighten-1';
            }
        },
        async loadBlockedQuestSummary() {
            try {
                const res = await blockedQuestServices.getSummary();
                this.blockedQuestCount = res.blocked_quest_count ?? 0;
            } catch (err) {
                /// 摘要失敗就當作沒有——選單少一項比整個選單壞掉好
                this.blockedQuestCount = 0;
            }
        },
        async loadSafetySummary() {
            try {
                const res = await safetyAlertServices.getSummary();
                this.unhandledCount = res.data?.unhandled_count ?? 0;
            } catch (err) {
                this.unhandledCount = 0;
            }
        }
    },
};
</script>

<style scoped></style>
